// extracted by mini-css-extract-plugin
export var container = "styles-module__container___qSnbS";
export var header = "styles-module__header___W3PH1";
export var subText = "styles-module__subText___WAEzb";
export var button = "styles-module__button___m0tDK";